import React from 'react'
import Grid from '@mui/material/Grid'
import Countdown from '../countdown/Countdown'


function Break({length, clockIsRunning, countdownCompleteCallback, secondsLeftInCurrentSession}: {length: number; clockIsRunning: boolean; countdownCompleteCallback: () => void; secondsLeftInCurrentSession: number}) {
  return (
    <Grid
      container
      sx={{
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      <Grid size={12}>
        <Countdown lengthInSeconds={length * 60}
          clockIsRunning={clockIsRunning}
          onCountdownComplete={countdownCompleteCallback}
          secondsLeftInCurrentSession={secondsLeftInCurrentSession}/>
      </Grid>
    </Grid>
  )
}

export default Break
